import React from 'react'
import Container from '../../../../components/Container'
import { FormPhaseProcess } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'

const ClientCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormPhaseProcess typeForm="create" />
  </Container>
)

export default ClientCreate
